import React from "react";

import { useMsal } from "@azure/msal-react";
import ApplicationContext from "./contexts/application";
import { Link } from "react-router-dom";
import { Container, useMediaQuery } from "@mui/material";
import AuthLayout from './components/AuthLayout';


function SignOut() {
    const { settings, saveSettings } = React.useContext(ApplicationContext);
    const { instance } = useMsal();
    const smallScreen = useMediaQuery('(min-height: 800px)');

    React.useEffect(() => {
        if (Object.keys(settings).length > 0 && settings.token !== "") {
            if (settings.oauth && settings.oauth.includes("microsoft")) {
                // Best-effort — MSAL can reject this (e.g. BrowserAuthError:
                // interaction_in_progress, if a prior redirect interaction hasn't fully
                // settled yet) and it must never block clearing the local session below.
                instance.logoutRedirect({ postLogoutRedirectUri: "/" }).catch((e) => {
                    console.warn('Microsoft sign-out failed (local session was cleared anyway):', e);
                });
            }

            saveSettings({
                "token": "",
                "userName": "",
                "password": "",
                "pageTitle": "",
                "name": "",
                "roles": [],
                "oauth": ""
            });
        }
    });

    return (
        <AuthLayout>
            <h2>Your session has ended or expired!</h2>
            <Link to="/">Log in</Link> again
        </AuthLayout>
    );
};

export default SignOut;